import { BIGQUERY_GROUP } from '../../../constants';

export const BIGQUERY_TYPE = 'clicked_header.registration.button_click_header';

export const BIGQUERY_EVENT = {
    type: BIGQUERY_TYPE,
    group: BIGQUERY_GROUP,
};
